import { Controller } from "@hotwired/stimulus"

// Manages a set of tab panels where inactive panels start hidden and lazy-loaded
// panels are fetched on first activation via Turbo Stream.
//
// Tab link usage:
//   data-action="click->lazy-tabs#switch"
//   data-lazy-tabs-target="tab"
//   data-panel-id="<panel-element-id>"
//
// Panel usage (any element, including turbo-frame):
//   data-lazy-tabs-target="panel"
//   id="<panel-element-id>"
//
// Lazy-load usage (on a panel):
//   data-lazy-src="<url>"  — sets turbo-frame src on first activation, triggering a
//                             frame navigation; attribute removed after to prevent re-fetch
export default class extends Controller {
  static targets = ["tab", "panel"]

  static values = {
    activeTab: String
  }

  connect() {
    const activeTab = this.tabTargets.find(t => t.classList.contains("active"))
    if (activeTab) {
      this.activeTabValue = activeTab.dataset.panelId
      this.#activate(activeTab, activeTab.dataset.panelId)
    }
  }

  switch(event) {
    event.preventDefault()
    
    const clickedTab = event.currentTarget
    const targetId = clickedTab.dataset.panelId

    const url = new URL(window.location.href)
    url.searchParams.set("tab", targetId)
    history.replaceState(null, "", url)
    this.activeTabValue = targetId
    this.#activate(clickedTab, targetId)
  }

  #activate(activeTab, targetId) {
    this.tabTargets.forEach(tab => {
      tab.classList.toggle("active", tab === activeTab)
    })

    this.panelTargets.forEach(panel => {
      const isActive = panel.id === targetId

      if (isActive) {
        panel.removeAttribute("hidden")
        var lazySrc = panel.dataset.lazySrc 
        if (lazySrc) {
          lazySrc += `?tab=${this.activeTabValue}`
          delete panel.dataset.lazySrc
          panel.setAttribute("src", lazySrc)
        }
      } else {
        panel.setAttribute("hidden", "")
      }
    })
  }
}
